import React, {
    createContext,
    useRef,
    useEffect,
    useState,
    useReducer,
    useMemo,
    useContext
} from 'react';
// import "preact/debug"
// import { Scrollbars } from 'react-custom-scrollbars';
import loadable from '@loadable/component';
import Header from './partials/Header';
import CartItemsList from './partials/CartItemsList';
import ExtraModule from './partials/ExtraModule';
import EmptyState from './partials/EmptyState';
import * as Utils from './Utils';
import { API_GATEWAY2 } from 'aws-exports';
import {
    CartItemsReducer,
    ADD_ITEM,
    MERGE_ITEM,
    REMOVE_ITEM,
    SET_ITEMS,
    SET_CART_NOTE,
    ADD_UPSELL,
    REMOVE_UPSELL
} from 'reducers/CartItemsReducer';
import Axios from 'axios';
import classNames from 'lib/classNames';
import useCampaign from 'hooks/useCampaign';
import { getAllOCUProducts } from './partials/CheckoutButton';
import Spinner from 'components/Spinner';
import CustomScroll from './partials/CustomScroll';
import useRefState from 'hooks/useRefState';
import { getCartItems } from 'shopify_script_tags/cart';
import HeaderATU from './partials/Header_ATU';

const ProductDetails = loadable(() => import('./partials/ProductDetails'));
const CodForm = loadable(() => import('./partials/CodForm'));
const VariantsPicker = loadable(() => import('./partials/VariantsPicker'));
const BundlesVariantsPicker = loadable(() => import('./partials/BundlesVariantsPicker'));
const Confetti = loadable(() => import('react-confetti'));

export const CartContext = createContext(null);
export const CartProvider = CartContext.Provider;

const Cart = ({
    campaigns = {},
    token,
    getCampaigns,
    setCampaigns,
    mergeCampaigns,
    mergeCompareAtMap,
    shop_url = null,
    isPreview = false,
    showSubscription = false,
    cart_items = [],
    cart_level_discount_applications = [],
    cart_currency,
    shop_settings,
    setShopSettings,
    close = null,
    isOpened = null,
    onInit = null,
    product_id = null,
    products,
    forcePreview = null,
    style = {},
    showCheckoutLoading,
    showComfirmOrderLoading,
    orderCodForm,
    setOrderCodForm,
    isCodFormSubmitted,
    setIsCodFormSubmitted,
    showATUAfterText,
    cartNote = '',
    hasWriteDiscountsScope = false,
    compareAtMap = {},
    setCompareAtMap,
    giftCurrentPreview,
    AppLocalStorage,
    bundlesVariantPickerPreview
}) => {
    const cart_ref = useRef(null);
    const header_ref = useRef(null);
    const [hasAutoDiscount, setHasAutoDiscount] = useState(
        Utils.CartHasAutoDiscount({ items: cart_items, cart_level_discount_applications })
    );
    const scrollbars_ref = useRef(null);
    const [variantsPickerShow, setVariantsPickerShow, variantsPickerShow_ref] = useRefState(false);
    const [variantPickerOptions, setVariantPickerOptions, setVariantPickerOptions_ref] =
        useRefState({});
    const [addedFromFbt, setAddedFromFbt] = useState([]);
    const [viewCartTracked, setViewCartTracked] = useState(false);
    const [showConfetti, setShowConfetti] = useState(0);
    const [active_slide, slickGoTo] = useState(0);
    const [previewed_product, setPreviewed_product] = useState(null);
    const [discountCode, setDiscountCode] = useState(null);
    const [rechargeSettings, setRechargeSettings] = useState(null);
    const [userIsTabbing, setUserIsTabbing] = useState(false);
    const [shipProtectState, setShipProtectState] = useState({selected:false, price: 0});
    const variantsPickerOverlay_ref = useRef(null);
    const bundlesVariantsPickerOverlay_ref = useRef(null);
    const [cartLoading, setCartLoading] = useState(false);
    const [bundlesVariantsPickerShow, setBundlesVariantsPickerShow] = useState(false);
    const [bundlesVariantsPickerOptions, setBundlesVariantsPickerOptions] = useState({});
    const [shopify_cart_state, dispatch] = useReducer(CartItemsReducer(AppLocalStorage), {
        items: cart_items,
        cart_level_discount_applications,
        cartNote,
        token,
        fbtUpsells: JSON.parse(AppLocalStorage.getItem('monster_uc_upsells') || '[]')
    });
    const [one_check_up_sell_product_id, ocu_campaign] = useCampaign(
        'one_check_up_sell',
        null,
        true
    )(campaigns, shopify_cart_state.items);
    const slider = {
        slickGoTo,
        active_slide
    };

    const add_to_cart = (
        {
            variant_id,
            quantity = 1,
            product_handle = null,
            product = null,
            properties,
            selling_plan
        },
        callback = null,
        formData
    ) => {
        if(window.monster_loading) setCartLoading(true);
        Utils.addToCart(
            {
                variant_id,
                quantity,
                properties,
                selling_plan,
                isPreview,
                shop_url,
                product_handle,
                product,
                currency: shop_settings.currency
            },
            formData
        ).then((data) => {
            const items = data?.items || [data];
            const item = data?.items ? Utils.findItem({ items: data.items, variant_id }) : data;
            if (data?.items) {
                dispatch({
                    type: SET_ITEMS,
                    items,
                    cart_level_discount_applications: data.cart_level_discount_applications
                });
            } else {
                dispatch({ type: ADD_ITEM, item });
            }

            if (!isPreview) {
                productionAddToCartCallBack(items);
            }
            if (callback) callback(item);
            if (window.monster_loading) setCartLoading(false);
        }).catch((error) => {
          if (window.monster_loading) setCartLoading(false);
        });
    };
    const productionAddToCartCallBack = async (items) => {
        const NonUndefinedCampaigns = campaigns || {};
        const campaignsKeys = Object.keys(NonUndefinedCampaigns).map(parseInt);
        items.filter(Boolean).forEach(async ({ product_id, variant_id, product_type }) => {
            const hasNoCampaigns =
                !campaigns ||
                !campaignsKeys.includes(product_id) ||
                (NonUndefinedCampaigns && NonUndefinedCampaigns[product_id] === []);
            if (hasNoCampaigns && product_type.toLowerCase() !== 'free_gift') {
                // const current_types = Object.entries(NonUndefinedCampaigns).filter(([id]) => productAddedToCart({ id })).map(([_, c]) => c).flat().map(({ type }) => type);
                const response = await getCampaigns(
                    [product_id],
                    [`${product_id}:${variant_id}`],
                    shopify_cart_state.token
                );
                const { settings, compareAtMap } = response;
                mergeCampaigns(response.campaigns);
                mergeCompareAtMap(compareAtMap);
                if (
                  settings.fromCampaign ||
                  !shop_settings.modules.order ||
                  (settings?.modules?.random_text && shop_settings.modules?.random_text?.active !== settings.modules.random_text?.active)
                ) {
                  setShopSettings({
                    ...shop_settings,
                    ...settings,
                    money_format: shop_settings.money_format,
                    modules: { ...shop_settings.modules, ...settings.modules },
                  });
                }
            }
        });
        // if(items.filter(Boolean).length){
        const newItems = await getCartItems()
        dispatch({ 
            type: SET_ITEMS,
            items: newItems.items,
            cart_level_discount_applications:newItems.cart_level_discount_applications
        });
        // }
    };
    window.mu_productionAddToCartCallBack = productionAddToCartCallBack;

    const update_cart_item = (
        { variant_id, line, quantity = 1, properties, selling_plan, sold_out = false },
        callback = null,
        formData
    ) => {
        if (window.monster_loading) setCartLoading(true);
        const item = Utils.findItem({
            line,
            items: shopify_cart_state.items,
            variant_id: variant_id
        });
        const currentQuantity = item ? item.quantity : 0;
        if (quantity === '+1') quantity = currentQuantity + 1;
        if (quantity === '-1') quantity = currentQuantity - 1;
        Utils.updateCartItem(
            {
                variant_id,
                line,
                quantity,
                properties,
                selling_plan,
                isPreview,
                state: shopify_cart_state
            },
            formData
        ).then(({ items, cart_level_discount_applications }) => {
                if (items.length === 1 && items[0].price === 0 && items[0].product_type === "free_gift") {
                  let { variant_id } = items[0];
                  return update_cart_item(
                    {
                      variant_id,
                      line: 1,
                      quantity: 0,
                    },
                    callback
                  );
                }
                if (!sold_out) {
                    if(!hasAutoDiscount){
                        dispatch({ type: SET_ITEMS, items, cart_level_discount_applications });
                    }
                    const item = Utils.findItem({ line, items, variant_id });
                    if (!isPreview) {
                        productionAddToCartCallBack(items);
                    }
                    // if (!item) return;
                    if (callback) callback(item, items);
                } else {
                    dispatch({
                        type: SET_ITEMS,
                        cart_level_discount_applications,
                        items: items.map((item) => {
                            if (item.variant_id === variant_id) {
                                return { ...item, quantity: 0, itemSoldOut: true };
                            }
                            return item;
                        })
                    });
                    if (callback) callback(null, items);
                }
                if (window.monster_loading) setCartLoading(false);
            })
            .catch((error) => {
                if (window.monster_loading) setCartLoading(false);
                if (callback) callback(null, null, error?.response?.data);
            });
    };

    const trackEvent = (data) => {
        return isPreview
            ? Promise.resolve(null)
            : Axios({
                  method: 'post',
                  url: `${API_GATEWAY2}/public/track`,
                  params: {
                      shop: shop_url
                  },
                  data
              });
    };

    const preview_product = (product, showAddCartButton = true) => {
        setPreviewed_product({ ...product, showAddCartButton });
        slider.slickGoTo(1);
    };
    const productAddedToCart = (product, byVariant) => {
        if (byVariant) return productAddedToCartByVariant(product);

        const product_id = Number(typeof product === 'object' ? product?.id : product);
        return !!shopify_cart_state.items.find((item) => item.product_id === product_id);
    };
    const productAddedToCartByVariant = (variant, items = undefined) => {
      items = items || shopify_cart_state.items;
        const variant_id = Number(typeof variant === 'object' ? variant?.id : variant);
        return !!items.find((item) => item.variant_id === variant_id);
    };

    const onlyOneItemAddedToCart = (product, byVariant) => {
        if (byVariant) return onlyOneItemAddedToCartByVariant(product);
        const product_id = Number(typeof product === 'object' ? product?.id : product);
        return !!shopify_cart_state.items.find(
            (item) => item.product_id === product_id && item.quantity === 1
        );
    };
    const onlyOneItemAddedToCartByVariant = (variant) => {
        const variant_id = Number(typeof variant === 'object' ? variant?.id : variant);
        return !!shopify_cart_state.items.find(
            (item) => item.variant_id === variant_id && item.quantity === 1
        );
    };

    const productNotAddedToCart = (product, byVariant) => !productAddedToCart(product, byVariant);

    const get_total = (type = null, items = null) => {
        const ocu_products = getAllOCUProducts(ocu_campaign);
        const filteredItems = (items || shopify_cart_state.items).filter((item) => {
            const ocu_product = ocu_products.find(
                ({ product }) => item.product_id.toString() === product?.id
            );
            return ocu_product
                ? ocu_product.include_in_atu
                : !(['free_gift', 'singleton_gift'].includes(item?.product_type?.toLowerCase()) && item?.price === 0);
        });
        const original = Utils.getTotal(items || shopify_cart_state.items, products);
        const filteredItemsTotal = Utils.getTotal(filteredItems);
        const discount = Utils.getDiscount({
            items: items || shopify_cart_state.items,
            cart_level_discount_applications: shopify_cart_state.cart_level_discount_applications,
            filteredItems,
            filteredItemsTotal,
            campaigns: campaigns || {},
            total: original,
            discountCode
        });
        const autoDiscountGifts = filteredItems.reduce((acc, item) => {
            const { discounts, price, line_level_discount_allocations } = item;
            const hasGiftAutoDiscount =
                discounts?.length &&
                line_level_discount_allocations?.find(({ discount_application }) =>
                    ['automatic', ''].includes(discount_application?.type)
                ) &&
                discounts[0]?.amount === price;
            return hasGiftAutoDiscount ? acc + price : acc;
        }, 0);
        const subtotal = original - discount;
        const compareAt = shop_settings.count_compare_at
            ? Utils.getCompareAtDiscount({
                  filteredItems: items || shopify_cart_state.items,
                  compareAtMap,
                  products
              })
            : 0;
        const output = {
            original,
            discount,
            subtotal,
            autoDiscountGifts,
            finalDiscount: compareAt + discount,
            total: original + compareAt
        };
        return type ? output[type] : output;
    };
    window.monster_getTotal = get_total;

    const productionAddToCart = (
        items,
        { variant_id, quantity, selling_plan, properties },
        callback,
        formData
    ) => {
        const item = items.find((item) => {
            const sameId = item.id === parseInt(variant_id);
            const sameProperties = properties
                ? JSON.stringify(properties) === JSON.stringify(item.properties)
                : true;
            const sellingPlanId = item?.selling_plan_allocation?.selling_plan?.id;
            const sameSellingPlane = selling_plan
                ? sellingPlanId === Number(selling_plan) // selling plan must be the same
                : !sellingPlanId; // selling plan must be undefined
            return sameId && sameProperties && sameSellingPlane;
        });
        const gfFileUpload = document.querySelector('.gf_file-upload');
        if (item && !gfFileUpload) {
            const line = items.indexOf(item) + 1;
            update_cart_item(
                {
                    variant_id,
                    line,
                    quantity: item.quantity + quantity,
                    properties,
                    selling_plan
                },
                callback,
                formData
            );
        } else {
            if (gfFileUpload) {
                const form = document.querySelector('form[action="/cart/add"]');
                const requiredFields = form.querySelectorAll('[required="required"]');
                for (let i = 0; i < requiredFields.length; i++) {
                    if (!requiredFields[i].value) {
                        form.requestSubmit();
                        return;
                    }
                }
            }
            add_to_cart(
                { variant_id, quantity, properties, selling_plan },
                (item) => {
                    if (callback) callback(item, items.concat([item]));
                },
                formData
            );
        }
    };

    const hasFont =
        shop_settings.font.custom && shop_settings.font.family ? shop_settings.font.family : false;

    const handleFirstTab = ({ keyCode }) => {
        if (keyCode === 9) {
            setUserIsTabbing(true);
            window.removeEventListener('keydown', handleFirstTab);
        }
    };
    // const handleResize = () => {
    // 	// setWindowHeight(window.innerHeight);
    // 	document.documentElement.style.setProperty('--screen-width', `${window.innerWidth}px`);
    // 	document.documentElement.style.setProperty('--screen-height', `${window.innerHeight + 60}px`);
    // };
    const [add_to_unlock_product_id, add_to_unlock, campaign_key, isGlobal] = useCampaign('add_to_unlock')(
        campaigns,
        shopify_cart_state.items
    );

    useEffect(() => {
        if (isPreview) return;
        const gifts = add_to_unlock?.goals
            .filter(({ reward_type }) => reward_type === 'gift')
            .map(({ gift: { product, products } }) => product || products)
            .flat()
            .filter(Boolean);
        const nonGiftsItems = shopify_cart_state.items.filter(
            ({ product_type }) =>
                !['free_gift', 'singleton_gift'].includes(product_type?.toLowerCase())
        );
        if (
            gifts?.length &&
            (productAddedToCart({ id: add_to_unlock_product_id }) ||
                (isGlobal && nonGiftsItems.length))
        ) {
            if (!!shop_settings.count_compare_at) {
                setCompareAtMap(
                    gifts?.reduce((acc, { variant_price, variants }) => {
                        if (!variants) return;
                        return Object.assign(
                            {},
                            acc,
                            ...variants.map(({ id, compare_at_price }) => ({
                                [id]: compare_at_price || variant_price
                            }))
                        );
                    }, {})
                );
            }
        } else {
            const deleteGifts = shopify_cart_state.items
                .filter(({ product_type }) =>
                    ['free_gift', 'singleton_gift'].includes(product_type?.toLowerCase())
                )
                .map(({ variant_id }) => update_cart_item({ variant_id, quantity: 0 }));
            Promise.all(deleteGifts);
        }
        // AppLocalStorage.setItem("cart_items", JSON.stringify(shopify_cart_state.items))
    }, [
        campaigns,
        shopify_cart_state.items,
        add_to_unlock_product_id,
        add_to_unlock,
        discountCode
    ]);

    useEffect(() => {
      if(bundlesVariantPickerPreview){
        setBundlesVariantsPickerOptions(bundlesVariantPickerPreview)
        setBundlesVariantsPickerShow(true)
      }else {
        setBundlesVariantsPickerOptions(null)
        setBundlesVariantsPickerShow(false)

      }
    }, [bundlesVariantPickerPreview])

    useEffect(() => {
      const updateCartState = () => {
        if (window.monster_refresh && !isPreview) window.monster_refresh(false);
      };

      updateCartState();
    }, [discountCode]);
    
    async function updateShippingProtectAppState({selected,price,variant}){
      window.mu_shipProtectSelected = selected;
      window.mu_shipProtectPrice = price;
      setShipProtectState({selected,price})
      if(!selected){
        const {items} = await getCartItems()
        if(productAddedToCartByVariant(variant, items)){
          update_cart_item({ variant_id: variant, quantity: 0 });
        }
      }
    }

    window.notifyMonsterUpsells = updateShippingProtectAppState

    useEffect(() => {
        if (onInit) onInit(productionAddToCart);
        window.addEventListener('keydown', handleFirstTab);
        return () => {
            window.removeEventListener('keydown', handleFirstTab);
        };
    }, []);

    useEffect(() => {
        if (hasFont && window.WebFont) {
            window.WebFont.load({
                google: {
                    families: [hasFont]
                }
            });
        }
    }, [hasFont]);

    const addFBTUpsell = (id) => {
        dispatch({ type: ADD_UPSELL, id });
    };

    const removeFBTUpsell = (id) => {
        dispatch({ type: REMOVE_UPSELL, id });
    };

    const setCartItems = (items, cart_level_discount_applications, fetchCampaigns) => {
        dispatch({ type: SET_ITEMS, items, cart_level_discount_applications });
        if (fetchCampaigns) productionAddToCartCallBack(items);
    };
    const addCartItem = (item) => {
        dispatch({ type: ADD_ITEM, item });
        // productionAddToCartCallBack([item])
    };
    const mergeCartItem = (item) => {
        dispatch({ type: MERGE_ITEM, item });
        // productionAddToCartCallBack([item])
    };
    const removeCartItem = (id) => dispatch({ type: REMOVE_ITEM, id });
    const setCartNote = (cartNote) => dispatch({ type: SET_CART_NOTE, cartNote });
    window.monster_setCartItems = setCartItems;
    window.monster_addCartItem = mergeCartItem;
    window.monster_mergeCartItem = mergeCartItem;
    window.monster_removeCartItem = removeCartItem;
    window.monster_setCartNote = setCartNote;
    const getRechargeSettings = async () => {
        try {
            const response = await Axios.get(window.location.href);
            const recharge_installed = response.data.includes('static.rechargecdn.com');
            const recharge_active = response.data.includes('data-recharge-theme');
            if (!recharge_installed || !recharge_active) return setRechargeSettings(undefined);
            const { data } = await Axios.get(
                `https://static.rechargecdn.com/store/${shop_url}/product/2020-12/products.json`
            );
            setRechargeSettings(data);
        } catch (error) {
            if(window.ReCharge && window.ReCharge.is_installed) setRechargeSettings(window.ReCharge);
            else setRechargeSettings(undefined);
        }
    };
    useEffect(() => {
        const atcs = document.querySelectorAll("button[data-pf-type='ProductATC']");
        atcs.forEach((atc) => {
            const form = atc.closest('form');
            atc.setAttribute('type', 'submit');
            if (form) {
                atc.removeAttribute('data-checkout');
                if (shop_url !== 'primary-beans.myshopify.com') {
                    atc.removeAttribute('data-pf-type');
                    atc.removeAttribute('data-product-id');
                }
            }
        });
        setCartItems(cart_items);
        if (rechargeSettings === null && !isPreview) getRechargeSettings();
    }, [cart_items]);

    useEffect(() => {
        if (!isPreview) return;

        if (forcePreview) {
            preview_product(forcePreview);
        } else if (
            window.location.pathname === '/settings/checkout' &&
            !shop_settings?.cod_settings?.is_form_in_cart
        ) {
            slider.slickGoTo(1);
        } else {
            slider.slickGoTo(0);
        }
    }, [isPreview, forcePreview, shop_settings?.cod_settings?.is_form_in_cart]);

    useEffect(() => {
        if (window.location.pathname === '/settings/checkout')
            slider.slickGoTo(
                shop_settings.cod_settings && shop_settings?.cod_settings?.is_form_in_cart ? 0 : 1
            );
    }, [shop_settings.cod_settings, shop_settings?.cod_settings?.is_form_in_cart]);

    useEffect(() => {
        if (!isPreview) {
            const hasAutoDiscount = Utils.CartHasAutoDiscount(shopify_cart_state);
            setHasAutoDiscount(hasAutoDiscount);
        }
    }, [shopify_cart_state.items]);

    useEffect(() => {
        // if (isOpened) iNoBounce.enable();
        // else iNoBounce.disable();
        if (isOpened && !viewCartTracked) {
            const campaignsIds = Object.values(campaigns)
                .flat(Infinity)
                .map((c) => {
                    const { campaign_key } = c;
                    return campaign_key && campaign_key[1];
                })
                .filter(Boolean);
            trackEvent({
                type: 'view_cart',
                campaigns: campaignsIds
            }).then((_) => {
                setViewCartTracked(true);
            });
        }
    }, [isOpened, viewCartTracked]);

    const goals = add_to_unlock?.goals || [];
    const filterGoalsBasedOnDiscount = Utils.FilterAtuGoals(goals, !!discountCode);
    const CAN_RENDER_ADD_TO_UNLOCK =
      filterGoalsBasedOnDiscount.length &&
      add_to_unlock?.isActive &&
      (productAddedToCart({ id: add_to_unlock_product_id }) ||
        (isGlobal && shopify_cart_state.items.length));
    const bundlesDiscounts = Utils.getDiscount({
      campaigns,
      items: shopify_cart_state.items,
      getBundlesOnly: true,
    });
    let stickyElements;
    return (
      <CartProvider
        value={{
          campaigns,
          token,
          cart_level_discount_applications:
            shopify_cart_state.cart_level_discount_applications,
          shopify_cart_items: shopify_cart_state.items,
          shopify_cart_upsells: shopify_cart_state.fbtUpsells,
          cartNote: shopify_cart_state.cartNote,
          setCartItems,
          addCartItem,
          removeCartItem,
          cart_currency,
          cart_ref,
          slider,
          cart_settings: shop_settings,
          Utils,
          add_to_cart,
          update_cart_item,
          preview_product,
          get_total,
          isPreview,
          showSubscription,
          previewed_product,
          setPreviewed_product,
          shop_url,
          productNotAddedToCart,
          onlyOneItemAddedToCart,
          productAddedToCart,
          scrollbars_ref: scrollbars_ref.current,
          close,
          discountCode,
          setDiscountCode,
          productionAddToCart,
          isOpened,
          trackEvent,
          setShowConfetti,
          variantsPickerShow,
          setVariantsPickerShow,
          setVariantPickerOptions,
          setBundlesVariantsPickerShow,
          setBundlesVariantsPickerOptions,
          showCheckoutLoading,
          showComfirmOrderLoading,
          orderCodForm,
          setOrderCodForm,
          isCodFormSubmitted,
          setIsCodFormSubmitted,
          showATUAfterText,
          setCartNote,
          addFBTUpsell,
          removeFBTUpsell,
          rechargeSettings,
          hasWriteDiscountsScope,
          compareAtMap,
          setCompareAtMap,
          giftCurrentPreview,
          AppLocalStorage,
          hasAutoDiscount,
          products,
          shipProtectState,
          cartLoading,
          setCartLoading,
        }}
      >
        <div
          className={classNames(
            "w-full h-full m-0 p-0 max-w-full flex flex-col relative",
            {
              "disable-outline": !userIsTabbing,
            }
          )}
          ref={cart_ref}
          style={{
            color: Utils.formatColor(shop_settings.font.color),
            background: Utils.formatColor(shop_settings.theme.background),
            fontSize: shop_settings.font.size,
            fontFamily: hasFont ? hasFont.split(":")[0] : "inherit",
            direction: shop_settings.rtl ? "rtl" : "ltr",
            borderRadius: shop_settings.curved ? "15px" : "",
          }}
        >
          {cart_ref.current && showConfetti !== 0 && (
            <Confetti
              width={cart_ref.current.offsetwidth}
              height={cart_ref.current.offsetHeight}
              recycle={false}
              numberOfPieces={showConfetti}
              gravity={0.2}
              onConfettiComplete={() => setShowConfetti(0)}
              initialVelocityX={5}
            />
          )}
          <Header title="My Cart" headerRef={header_ref} />
          <CustomScroll
            scrollRef={scrollbars_ref}
            thumbBg={Utils.formatColor(shop_settings.theme.secondary)}
            trackBg={Utils.formatColor(shop_settings.theme.background)}
            isMobile={Utils.isMobile()}
            className={classNames("flex-1")}
            style={{
              marginBottom:
                shop_settings.curved &&
                !shop_settings.modules.checkout_button.fix_checkout_container
                  ? "15px"
                  : "",
            }}
          >
            <div
              style={{ minHeight: "100%" }}
              className={classNames(
                "slider w-full min-w-full flex-1 overflow-hidden flex flex-col"
              )}
            >
              <div
                className={classNames(
                  "flex-1 flex transform transition-transform duration-300 ease-out",
                  {
                    "translate-x-full": active_slide && shop_settings.rtl,
                    "-translate-x-full": active_slide && !shop_settings.rtl,
                    "translate-x-0": !active_slide,
                  }
                )}
              >
                {shopify_cart_state.items.length ? (
                  <div
                    className={classNames(
                      "w-full min-w-full flex flex-col h-auto"
                    )}
                  >
                    {shop_settings.modules.checkout_button
                      .fix_checkout_container &&
                      !!CAN_RENDER_ADD_TO_UNLOCK && (
                        <HeaderATU
                          campaign_id={campaign_key && campaign_key[1]}
                          add_to_unlock={add_to_unlock}
                          bundlesDiscounts={bundlesDiscounts}
                        />
                      )}
                    <CartItemsList />
                    {shop_settings.cod_settings &&
                      shop_settings.cod_settings.is_active &&
                      shop_settings?.cod_settings?.is_form_in_cart && (
                        <CodForm />
                      )}
                    {shop_settings.modules.order &&
                      shop_settings.modules.order
                        .filter(
                          (key) =>
                            !shop_settings.modules.checkout_button
                              .fix_checkout_container ||
                            key !== "checkout_button"
                        )
                        .map((key, i) => (
                          <ExtraModule
                            key={key}
                            moduleKey={key}
                            modules={shop_settings.modules}
                            cartNote={shopify_cart_state.cartNote}
                          />
                        ))}
                  </div>
                ) : (
                  <EmptyState />
                )}

                <ProductDetails
                  style={{
                    maxHeight:
                      active_slide === 0 && header_ref.current
                        ? `calc(100vh - ${header_ref.current.offsetHeight}px)`
                        : undefined,
                  }}
                  add_to_unlock={add_to_unlock}
                />
                {(isPreview ||
                  (shop_settings.cod_settings &&
                    shop_settings.cod_settings.is_active)) && <CodForm />}
              </div>
            </div>
            {/* </div> */}
            {/* </Slider> */}
          </CustomScroll>

          {shopify_cart_state.items.length > 0 &&
            shop_settings.modules.order &&
            shop_settings.modules.order
              .filter(
                (key) =>
                  shop_settings.modules.checkout_button
                    .fix_checkout_container && key === "checkout_button"
              )
              .map((key, i) => (
                <ExtraModule
                  key={key}
                  moduleKey={key}
                  modules={shop_settings.modules}
                  cartNote={shopify_cart_state.cartNote}
                />
              ))}

          {variantsPickerShow_ref.current && variantsPickerShow && (
            <div className={classNames("absolute inset-0 z-20")}>
              <div
                className={classNames(
                  "flex flex-col justify-end w-full h-full overflow-hidden transition-colors duration-300 ease-in cursor-pointer"
                )}
                ref={variantsPickerOverlay_ref}
                onClick={(event) => {
                  event.preventDefault();
                  if (event.target === variantsPickerOverlay_ref.current) {
                    if (variantPickerOptions.onClose)
                      variantPickerOptions.onClose();
                    setVariantsPickerShow(false);
                  }
                }}
                style={{
                  background: variantsPickerShow
                    ? "rgba(0,0,0,0.2)"
                    : "transparent",
                  borderRadius: shop_settings.curved ? "15px" : "",
                }}
              >
                <div
                  style={{}}
                  className={classNames(
                    "max-h-full",
                    variantsPickerShow
                      ? "animate-slide-up"
                      : "animate-slide-down"
                  )}
                >
                  <VariantsPicker
                    {...variantPickerOptions}
                    CustomScroll={CustomScroll}
                    parentRef={variantsPickerOverlay_ref}
                  />
                </div>
              </div>
            </div>
          )}
          {bundlesVariantsPickerShow && (
            <div className={classNames("absolute inset-0 z-20")}>
              <div
                className={classNames(
                  "flex flex-col justify-end w-full h-full overflow-hidden transition-colors duration-300 ease-in"
                )}
                ref={bundlesVariantsPickerOverlay_ref}
                onClick={(event) => {
                  if (
                    event.target === bundlesVariantsPickerOverlay_ref.current
                  ) {
                    setBundlesVariantsPickerShow(false);
                    if (bundlesVariantsPickerOptions.onClose)
                      bundlesVariantsPickerOptions.onClose();
                  }
                }}
                style={{
                  background: bundlesVariantsPickerShow
                    ? "rgba(0,0,0,0.2)"
                    : "transparent",
                  borderRadius: shop_settings.curved ? "15px" : "",
                }}
              >
                <div
                  style={{}}
                  className={classNames(
                    "max-h-full",
                    bundlesVariantsPickerShow
                      ? "animate-slide-up"
                      : "animate-slide-down"
                  )}
                >
                  <BundlesVariantsPicker
                    {...bundlesVariantsPickerOptions}
                    CustomScroll={CustomScroll}
                    parentRef={bundlesVariantsPickerOverlay_ref}
                  />
                </div>
              </div>
            </div>
          )}
          {cartLoading && (
            <div
              className={classNames(
                "absolute h-full w-full flex-center flex-col"
              )}
              style={{ background: "#30303030" }}
            >
              <Spinner />
            </div>
          )}
        </div>
      </CartProvider>
    );
};

export default Cart;
